import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import 'jquery-minicolors/jquery.minicolors.min'
import 'jquery-minicolors/jquery.minicolors.png'
import 'angular-minicolors/angular-minicolors';
import CampaignsEdit from './campaignsEdit';
import CampaignsForm from './campaignsForm';
import sspMarginForm from './sspMarginForm';
import CampaignsTargeting from './campaignsTargeting';
import CampaignsIndex from './campaignsIndex';
import CampaignsShow from './campaignsShow';
import CampaignsClone from './campaignsClone';
import CampaignsTable from './campaignsTable';
import CampaignVariationsGetter from '../../services/variationsServices.js';
import CampaignsExplore from './campaignsExplore';
import CampaignsExploreAxisSettings from './campaignsExploreAxisSettings';
import EditBidPriceModal from './editBidPriceModal';
import StopReasonModal from './stopReasonModal';

export default angular.module('app.components.campaigns', [
  'ui.router',
  'minicolors',
  CampaignsEdit.name,
  CampaignsForm.name,
  sspMarginForm.name,
  CampaignsTargeting.name,
  CampaignsIndex.name,
  CampaignsShow.name,
  CampaignsClone.name,
  CampaignsTable.name,
  CampaignVariationsGetter.name,
  CampaignsExplore.name,
  CampaignsExploreAxisSettings.name,
  EditBidPriceModal.name,
  StopReasonModal.name
])
  .config(function($stateProvider){
    $stateProvider
      .state('app.campaigns', {
        abstract: true,
        url: '/campaigns/:gameId',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous', 'SELLER_ONLY'],
            redirectTo: 'login'
          }
        },
        resolve: {
          updateCurrentGame: function($stateParams,GamesResource,currentGame){
            return GamesResource.one($stateParams.gameId).get().then(game => {
              currentGame.onNext(game);
            });
          }
        }
      })
      .state('app.campaigns.index', {
        url: '',
        template: '<campaigns-index></campaigns-index>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.campaigns.index');
          }
        }
      })
      .state('app.campaigns.new', {
        url: '/new/:type',
        template: '<campaigns-edit></campaigns-edit>',
        params: { campaign: null, variations: null, cloning: null, audience: null },
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.campaigns.new');
          }
        }
      })
      .state('app.campaigns.show', {
        url: '/:id',
        template: '<campaigns-show></campaigns-show>',
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.campaigns.show', {id: $stateParams.id})
          }
        }
      })
      .state('app.campaigns.explore', {
        url: '/:id/explore/:axisName',
        template: '<campaigns-explore></campaigns-explore>',
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.campaigns.explore', {id: $stateParams.id});
          }
        }
      })
      .state('app.campaigns.edit', {
        url: '/:id/edit',
        template: '<campaigns-edit></campaigns-edit>',
        params: { activeTab: null },
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.campaigns.edit', {id: $stateParams.id})
          }
        }
      })
      .state('app.campaigns.clone', {
        template: '<campaigns-clone></campaigns-clone>',
        params: { campaign: null, variations: null },
      })
  })
  .directive('campaignName', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        campaign: '='
      },
      template: `<span>{{ campaign.name || ('new' | translateWith:'campaign') }}
        <span ng-if='campaign.type == "Engagement"' class="c-pill c-pill--orange u-ml--">{{ '$campaignType.' + campaign.type | translate }}</span>
        <span ng-if='campaign.type == "EngagementCPC"' class="c-pill c-pill--yellow u-ml--">{{ '$campaignType.' + campaign.type | translate }}</span>
        <span ng-if='campaign.type == "EngagementCPA"' class="c-pill c-pill--red u-ml--">{{ '$campaignType.' + campaign.type | translate }}</span>
        <span ng-if='campaign.type == "EngagementCPI"' class="c-pill c-pill--red u-ml--">{{ '$campaignType.' + campaign.type | translate }}</span>
        <span ng-if='campaign.type == "EngagementCPI"' class="c-pill c-pill--red u-ml--">{{ '$campaignType.' + campaign.type | translate }}</span>
        <span ng-if="isCampaignOfPlatformType(campaign, 'Android')" class="span.small-rounded-icon" gg-icon="platform-android-green"></span>
        <span ng-if="isCampaignOfPlatformType(campaign, 'iOS')" class="span.small-rounded-icon" gg-icon="platform-ios"></span>
      </span>`,
      controller: function ($scope, $element) {
        $scope.isCampaignOfPlatformType = function (campaign, value) {
          return campaign.urls && campaign.urls[value];
        };
      }
    };
  })
  .directive('campaignStatus', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        campaign: '=',
        showText: '=?'
      },
      template: `
      <span ng-class='{"c-text--success": campaign.status == "active", "c-status-icon--pause": campaign.status != "active"}'>
        <span class="c-campaign-status" ng-if="campaign.status == 'paused_due_to_media_cost'">
          <span gg-icon="status-pause2" class="c-status-icon c-status-icon--pause c-status-paused-due-to-media-cost"></span>
          <span ng-if="showText" class="c-campaign-status__text c-status-paused-due-to-media-cost">{{ 'budgetLimit' | translate }}</span>
        </span>
        <span class="c-campaign-status" ng-if="campaign.status == 'paused_due_to_budget'">
          <span gg-icon="status-pause2" class="c-status-icon c-status-icon--pause"></span>
          <span ng-if="showText" class="c-campaign-status__text">{{ 'budgetLimit' | translate }}</span>
        </span>
        <span class="c-campaign-status" ng-if="campaign.status == 'paused'">
          <span gg-icon="status-pause" class="c-status-icon c-status-icon--pause"></span>
          <span ng-if="showText" class="c-campaign-status__text">{{ 'paused' | translate }}</span>
        </span>
        <span class="c-campaign-status" ng-if="campaign.status == 'active'">
          <span gg-icon="status-play" class="c-status-icon c-status-icon--play"></span>
          <span ng-if="showText" class="c-campaign-status__text">{{ 'active' | translate }}</span>
        </span>
      </span>`
    };
  })



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaigns.js
 **/